
































































































import { Vue, Component, Watch } from 'vue-property-decorator';
//@ts-ignore
import ResSplitPane from 'vue-resize-split-pane';
import DetailPatent from '@/pantallas/Camaras/EnVivo/DetailPatent.vue';
import { fetchCamaraModulo } from '@/pantallas/Camaras/fetchCamaraModulos';
import InLiveCams from '@/pantallas/Camaras/EnVivo/InLiveCams.vue';
import { LoadingService } from '@/services/loadingService';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';

@Component({
    components: { ResSplitPane, DetailPatent, InLiveCams },
})
export default class CamaraEnVivoOperaciones extends Vue {
    // State
    readonly mapName: string = 'envivoOp-mapa'; // Id del mapa
    loadingService = new LoadingService(); // Objeto para mostrar el modal de "cargando"
    $snotify: any; // Objeto para emitir alertas en la pantalla
    active: any = [];

    fullCams: boolean = false; // Var para manejar cuando se cierre y se abra la ventana que visualiza la cámara
    searchPatent: string = ""; // Var de búsqueda en el arbol de cámaras
    searchPatent_tmp1: string = ""; // Var de búsqueda en el arbol de cámaras
    treeViewList: any[] = []; // Var que contiene el valor del arbol
    openNodes: any[] = []; // Var que contiene los nodos del arbol

    patents: any[] = []; // Lista de cámaras del arbol
    patents_original: any[] = []; // Lista de cámaras del arbol (respaldo)
    limitAncientCams: number = 5; // Límite para total de cámaras a visualizar al momento (por defecto 5)
    url_live: string = ""; // Url para cámara 
    listCam: any[] = []; // Lista de cámaras en emisión
    current_patent: any = {}; // Cámara seleccionada
    totalActives: number = 0; // Total de Cámaras activas en el arbol 
    totalLength: number = 0;  // Total de Cámaras en el arbol de cámaras
    isFilter: boolean = false; // Validación por si está la búsqueda de patente activa
    current_id_camera: number = -1; // Cámara seleccionada actualmente
    listCamTimeout: any[] = [];
    isActiveGetPatents: boolean = false;
    configVss: any = {};


    lastLat: any = -30.75442;
    lastLong: any = -70.4300433;
    infoWindows: google.maps.InfoWindow;
    map: google.maps.Map = null;
    marker: google.maps.Marker = null;

    // get para obtener cuando no haya ninguna cámara seleccionada
    get emptyPatentCam(): boolean {
        return this.listCam.length > 0;
    }
    get emptyPatent(): boolean {
        return !(Object.keys(this.current_patent).length === 0);
    }

    // Obtener la data del arbol
    async getPatents() {
        if (this.isActiveGetPatents) {
            return;
        }
        this.isActiveGetPatents = true;
        this.loadingService.showLoading("Por favor espere...", "geInLivePatents");

        // Body para enviar al servicio
        const body: any = {
            id_cliente: this.getClientID(),
            id_user: this.getUserID(),
            operaciones: 'SI',
            search: this.searchPatent_tmp1
        };
        await fetchCamaraModulo(body, 'getInLivePatents')
            .then((response: any) => {
                if (response.data.CODIGO_RESPUESTA == '1') {
                    this.patents = response.data.data;
                    this.patents_original = JSON.parse(
                        JSON.stringify(response.data.data)
                    );
                    this.url_live = response.data.url_live;
                    this.totalLength = response.data.totalCameras;
                    this.totalActives = response.data.totalActives;
                } else {
                    this.$snotify.error(response.data.MENSAJE_RESPUESTA);
                }
            })
            .catch((error: any) => {
                console.log(error);
                this.$snotify.error('Error al obtener las cámaras');
            })
            .finally(() => {
                this.loadingService.hideLoading("geInLivePatents");
                this.isActiveGetPatents = false;
                //this.searchPatent_tmp1 = '';
                this.clear();
            });
    }

    clear() {
        //clearInterval(this.timerUpdateCoordinates);
        this.treeViewList = [];
        // @ts-ignore
        this.$refs.tree.updateAll(false);
        this.current_patent = {};
        CamaraEventBus.$emit('handleCams', [], 'clear');
        this.listCam = [];
    }


    // Funciones para el renderizado del arbol
    getColor(item: any) {
        if (item.ty == 'parent' || item.ty == 'fleet') {
            return (item.e ? 'green' : 'red')
        } else {
            return item.color;
        }
    }
    getState(state: boolean) {
        return (state ? 'Conectado' : 'Desconectado')
    }
    getIcon(type: any) {
        if (type == 'parent') {
            return 'local_shipping'
        } else if (type == 'fleet') {
            return 'group'
        } else {
            return 'videocam'
        }
    }

    initiliazeHowenVss(){
    this.loadingService.showLoading("Por favor espere...", "initiliazeHowenVss");
    fetchCamaraModulo({}, 'getConfigVss')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.configVss = response.data.data;
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al obtener la configuración para vss');
      })
      .finally(() => {
        this.loadingService.hideLoading("initiliazeHowenVss");
      });
  }

    // Función que se gatilla cuando se selecciona una cámara del gat
    async handleList(item: any) {
        var self = this;
        // Valida si el padre (patente) ya ha sido abierto anteriormente, de no haber sido abierto, se salta el proceso
        if (item.ty == 'parent' && !item.o) {
            return;
        }

        // Validación para las cámaras antiguas:  Solo se puede visualizar n cámaras a la vez
        if (item.checkbox && item.tipo_live.toLowerCase() == 'antiguo') {
            const activeOldCams: any[] = this.listCam.filter((itemF: any) => itemF.tipo_live.toLowerCase() == 'antiguo')
            if (item.type == 'parent') {
                if (this.getLengthParent(item) + activeOldCams.length > this.limitAncientCams) {
                    this.$snotify.error(
                        'No se puede tener más de ' + this.limitAncientCams + ' canales en visualización a la vez para este tipo de cámaras'
                    );
                    setTimeout(() => {
                        item.checkbox = false;
                    }, 300);
                    return;
                }
            } else if (item.type == 'children') {
                if (1 + activeOldCams.length > this.limitAncientCams) {
                    this.$snotify.error(
                        'No se puede tener más de ' + this.limitAncientCams + ' canales en visualización a la vez para este tipo de cámaras'
                    );

                    setTimeout(() => {
                        item.checkbox = false;
                    }, 300);
                    return;
                }
            }
        }

        if (item.type == 'parent') {
            // Is camera
            this.updateChildrens(item);
            if (item.checkbox) {
                this.handleCam(item);
            }
        } else if (item.type == 'children') {
            // Is channel
            this.setColorCam(item);
            var patent = {};
            if (!this.isFilter) {
                patent = this.patents[item.indexFleet].children[item.indexParent];
            } else {
                patent = this.patents_original[item.indexFleet].children[
                    item.indexParent
                ];
            }
            this.updateParent(patent);

            if (item.checkbox) {
                this.handleCam(patent);
            }
        } else if (item.type == 'fleet') {
            return;
        }
        if (item.checkbox && this.current_id_camera != item.id_camara) {
            this.resetMap();
        }
        this.current_id_camera = item.id_camara;


        setTimeout(() => {
            self.updateCam(item);
        }, 150);
        this.loading(300);
        this.generateListCamsOperation(item);
    }

    generateListCamsOperation(item: any) {
        var self = this;
        this.listCam = [];
        var listCamHandler: any[] = [];
        for (var [indexFleet, fleet] of this.patents.entries()) {
            for (var [indexPatent, patent] of fleet.children.entries()) {
                for (var [indexChildren, children] of patent.children.entries()) {
                    if (children.checkbox) {
                        listCamHandler.push({
                            ...children,
                            patent: patent.name,
                            url_live: patent.url_live,
                            id_camara: patent.id_camara,
                            tipo_live: patent.tipo_live,
                        });
                    }
                }
            }
        }
        this.listCam = listCamHandler;
        setTimeout(() => {
            self.listCamTimeout = listCamHandler;
        }, 400);
    }

    loading(time: any) {
        this.loadingService.showLoading();
        var self = this;
        setTimeout(() => {
            self.loadingService.hideLoading();
        }, time);
    }


    updateCam(item: any) {
        const action: string = item.checkbox ? 'insert' : 'remove';
        if (item.type == 'parent') {
            CamaraEventBus.$emit('handleCams', item.children, action);
        } else if (item.type == 'children') {
            var cams: any[] = [];
            cams.push(item);
            CamaraEventBus.$emit('handleCams', cams, action);
        }
    }

    handleCam(patent: any) {
        this.current_patent = patent;
    }


    updateParent(item: any) {
        var allDisabled: boolean = true;
        var allEnabled: boolean = true;
        for (var [index, cam] of item.children.entries()) {
            if (item.children[index].checkbox) {
                allDisabled = false;
            } else {
                allEnabled = false;
            }
        }
        if (allEnabled) {
            item.checkbox = true;
        } else if (allDisabled) {
            item.checkbox = false;
        }
    }

    resetMap() {
        this.chargeCoords();
        var self = this;
    }

    async chargeCoords() {
        var coordinates: any = await this.getCameraCoordinates();
        this.lastLat = coordinates.latitud;
        this.lastLong = coordinates.longitud;
        this.renderMap(
            coordinates.latitud,
            coordinates.longitud,
            coordinates.fecha_actividad
        );
    }

    async getCameraCoordinates(): Promise<{}> {
        const body: {} = {
            id_camera: this.current_patent.id_camara,
        };
        return fetchCamaraModulo(body, 'getCameraCoordinates')
            .then((response: any) => {
                if (response.data.CODIGO_RESPUESTA == '1') {
                    if (response.status == 200) {
                        return response.data.data;
                    } else {
                        this.$snotify.error('Error al obtener coordenadas');
                        return {};
                    }
                } else {
                    this.$snotify.error(response.data.MENSAJE_RESPUESTA, {
                        timeout: 3000,
                    });
                }
            })
            .catch((error: any) => {
                console.log(error);
                this.$snotify.error('Error al obtener coordenadas');
                return {};
            })
            .finally(() => {
                return {};
            });
    }

    initializeRenderMap() {
        var lat = this.lastLat;
        var lon: number = this.lastLong;

        var myLatlng = new google.maps.LatLng(lat, lon);

        var mapOptions: any = {
            zoom: 9,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: myLatlng,
            mapTypeControl: false,
            streetViewControl: true,
            gestureHandling: 'greedy',
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            minZoom: 2,
            maxZoom: 20,
        };
        this.infoWindows = new google.maps.InfoWindow({
            content: '',
        });

        this.map = new google.maps.Map(
            document.getElementById(this.mapName),
            mapOptions
        );
    }

    renderMap(lat: any, lon: any, date: any) {
        var myLatlng = new google.maps.LatLng(lat, lon);

        try {
            this.marker.setMap(null);
        } catch (e) {
            console.log(e);
        }
        this.marker = new google.maps.Marker({
            position: myLatlng,
            map: this.map,
            icon: {
                url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                labelOrigin: new google.maps.Point(75, 32),
                size: new google.maps.Size(32, 32),
                anchor: new google.maps.Point(16, 32),
            },
            label: {
                text: 'Posición',
                color: '#C70E20',
                fontWeight: 'bold',
            },
        });
        this.infoWindows.setContent(this.generateHtml(lat, lon, date));
        this.map.setCenter(myLatlng);

        var self = this;
        google.maps.event.addListener(this.marker, 'click', function () {
            self.infoWindows.open(self.map, self.marker);
            // window.open(`https://maps.google.com/?q=${lat},${lon}`);
        });

        // this.infoWindow.open(this.map, marker);

        const mapContainer = document.getElementById(this.mapName);

        mapContainer.addEventListener('mousemove', this.updateMouseCoordinates, {
            passive: true,
        });
    }

    updateMouseCoordinates(event: MouseEvent) {
        const point2LatLng = (point: google.maps.Point) => {
            const { map } = this;
            const topRight = map
                .getProjection()
                .fromLatLngToPoint(map.getBounds().getNorthEast());
            const bottomLeft = map
                .getProjection()
                .fromLatLngToPoint(map.getBounds().getSouthWest());
            const scale = Math.pow(2, map.getZoom());
            const worldPoint = new google.maps.Point(
                point.x / scale + bottomLeft.x,
                point.y / scale + topRight.y
            );
            return map.getProjection().fromPointToLatLng(worldPoint);
        };
    }

    generateHtml(lat: string, lon: string, date: string): string {
        var html: string = '';
        const url: string = `https://maps.google.com/?q=${lat},${lon}`;
        html =
            '<div id="content">' +
            '<div id="siteNotice">' +
            '</div>' +
            '<h1 id="firstHeading" class="firstHeading">Última Actividad</h1>' +
            '<div id="bodyContent">' +
            '<p></p>' +
            `<p><b style="font-weight: 700;">Fecha: </b> ${date}</p>` +
            `<p><b style="font-weight: 700;">Coordenadas: </b> <a href="${url}" target="_blank">Presionar Link</a></p>` +
            '</div>' +
            '</div>';

        return html;
    }

    setColorCam(cam: any) {
        if (cam.checkbox) {
            cam.color = 'green';
        } else {
            cam.color = '';
        }
    }

    updateChildrens(item: any) {
        for (var [index, cam] of item.children.entries()) {
            item.children[index].checkbox = item.checkbox;
            this.setColorCam(item.children[index]);
        }
    }

    getLengthParent(item: any): number {
        var total: number = 0;
        for (var chl of item.children) {
            let index: number = this.listCam.findIndex(
                (itemL: any) => itemL.id == chl.id
            );
            if (index == -1) {
                total += 1;
            }
        }
        return total;
    }

    // Función que se gatilla cuando el html se monta en el DOM del navegador 
    async mounted() {
        // Llamar a la lista de cámaras del arbol
        this.initiliazeHowenVss();
        this.getLimitOldCams();
        await this.getPatents();
        this.initializeRenderMap();

        this.dragElement(document.getElementById('separator'), 'H');
    }

    async getLimitOldCams() {
        this.loadingService.showLoading();
        fetchCamaraModulo({}, 'getLimitAncientCam')
            .then((response: any) => {
                if (response.data.CODIGO_RESPUESTA == '1') {
                    this.limitAncientCams = response.data.limit;
                } else {
                    this.$snotify.error(response.data.MENSAJE_RESPUESTA);
                }
            })
            .catch((error: any) => {
                console.log(error);
                this.$snotify.error('Error al obtener el límite de las cámaras Cms6');
            })
            .finally(() => {
                this.loadingService.hideLoading();
                this.isActiveGetPatents = false;
                //this.searchPatent_tmp1 = '';
                this.clear();
            });
    }

    // Función que se gatilla al abrir un nodo padre del arbol (obtiene los hijos)
    async fetchChildrens(node: any) {
        //await this.esperar(3000);
        await fetchCamaraModulo({ id_camara: node.i }, 'getInfoCam')
            .then((response: any) => response.data.data)
            .then((data: any) => {
                // Agregamos los canales a la cámara
                node.children = this.mapChildrens(data, node);

                // Agregamos los datos adicionales a la cámara
                node.sistema = data.sistema;
                node.ultima_conexion = data.ultima_conexion;
                node.url_live = data.url_live;
                node.id_camara = data.id_camara;
                node.estado = data.estado;
                node.type = "parent";
                node.tipo_live = data.tipo_live ? data.tipo_live : 'NUEVO';

            })
            .catch((error: any) => {
                console.log("Error: ", error)
            })
            .finally(() => {
                // o (open) la cambiamos a true para constar que se ha abierto la patente en el arbol
                node.o = true;
                // Si se abrió la patente y a parte se seleccionó para mostrar, se manda el evento para mostrar cámaras:
                if (node.checkbox) {
                    this.handleList(node);
                }
            })
    }

    mapChildrens(cam: any, node: any) {
        let chanels: any[] = [];
        let id: number = node.id;
        for (let chl of cam.channels) {
            id++;
            let obj: any = {
                "id": id,
                "timeout": 1,
                "sistema": cam.sistema,
                "errorMessageStreamax": "",
                "url_live": cam.url_live + "audio=1&chl=" + chl,
                "background": false,
                "patent": node.name,
                // "fps1": "10",
                "tstr": "1",
                "ty": "children",
                "type": "children",
                "id_camara": node.i,
                "name": chl,
                "loading": 0,
                "disabled": node.disabled,
                "tipo_live": cam.tipo_live,
                "color": "",
                "checkbox": false,
                "indexParent": node.ind,
                "indexFleet": node.ip
            }

            chanels.push(obj);
        }
        return chanels;
    }

    // Función que se gatilla cuando se reinicia el arbol desde el botón del "reload"
    handleReloadPatents() {
        this.getPatents();
    }

    // Función que se gatilla cuando se introduce texto en el buscador
    async handleChangePatent() {
        this.getPatents();
     }

    getUserID(): number {
        let user = localStorage.getItem('user');
        let id = JSON.parse(user.replace(/'/g, '"')).id;
        return parseInt(id);
    }

    getClientID(): number {
        return parseInt(localStorage.getItem('clienteDefecto'));
        // return 3798;
    }


    closeFirstDiv() {
        this.fullCams = false;
        document.getElementById('first').style.width = '75%';
        document.getElementById('second').style.width = '25%';
        CamaraEventBus.$emit('refreshCam');
    }

    fullFirstDiv() {
        this.fullCams = true;
        document.getElementById('first').style.width = '99%';
        document.getElementById('second').style.width = '0px';
        CamaraEventBus.$emit('refreshCam');
    }

    dragElement(element: any, direction: any) {
        let md: any = {}; // remember mouse down info
        const first = document.getElementById('first');
        const second = document.getElementById('second');
        var self = this;
        element.onmousedown = onMouseDown;

        function onMouseDown(e: any) {
            md = {
                e,
                offsetLeft: element.offsetLeft,
                offsetTop: element.offsetTop,
                firstWidth: first.offsetWidth,
                secondWidth: second.offsetWidth,
            };

            document.onmousemove = onMouseMove;
            document.onmouseup = () => {
                document.onmousemove = document.onmouseup = null;
                // if (self.fullCams) {
                //   self.fullCams = false;
                // }
                CamaraEventBus.$emit('refreshCam');
            };
        }

        function onMouseMove(e: any) {
            var delta = { x: e.clientX - md.e.clientX, y: e.clientY - md.e.clientY };

            if (direction === 'H') {
                // Horizontal
                // Prevent negative-sized elements
                delta.x = Math.min(Math.max(delta.x, -md.firstWidth), md.secondWidth);

                element.style.left = md.offsetLeft + delta.x + 'px';
                first.style.width = md.firstWidth + delta.x + 'px';
                second.style.width = md.secondWidth - delta.x + 'px';
            }
        }
    }

    get filter() {
        return (item: any, search: any, textKey: any) =>
            item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1;
    }

}

